module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor-v2-77a07421b59af3d3fbf8de80d954df14.svg";